import { all } from "redux-saga/effects";
import { getKeyRequestsWatcher } from "./getKeyRequests.saga";

export default function* rootSaga() {
    yield all([getKeyRequestsWatcher()]);
}
